/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_Model_SettingsInputs */



/**
* | output |
* | --- |
* | "Configure which AI models are available to your organization." |
*
* @param {Plan_Gate_Desc_Model_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_model_settings = /** @type {((inputs?: Plan_Gate_Desc_Model_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_Model_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie, welche KI-Modelle Ihrer Organisation zur Verfügung stehen.")
	return /** @type {LocalizedString} */ ("Configure which AI models are available to your organization.")
});